function logoutWhenTokenExpires({ store, router }) {
  function onFulfilled(response) {
    return Promise.resolve(response);
  }

  function onRejected(error) {
    if (error.response.status === 401 && error.response.config.url !== '/auth/login') {
      store.dispatch('auth/expireAccessToken');
      router.push({ name: 'Auth-Login' });
    }

    return Promise.reject(error);
  }

  return [onFulfilled, onRejected];
}

export default logoutWhenTokenExpires;
